import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { forgotPassword } from "../../../services/authApiService";

const ForgotPasswordModal = ({ show, onHide, onSuccess }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (!email) {
      setError(t('auth.email_required'));
      return;
    }

    setLoading(true);

    try {
      console.log("📡 Llamando a forgotPassword con email:", email);
      const result = await forgotPassword(email);
      console.log("✅ Respuesta del backend:", result);
      
      setSuccess(true);
      console.log("✅ Solicitud de reset enviada exitosamente");
    } catch (err) {
      console.error("❌ Error en forgotPassword:", err);
      setError(err.message || t('auth.error_requesting_reset'));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail("");
    setError("");
    setSuccess(false);
    onHide();
  };

  if (!show) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000000,
        padding: "20px"
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: "#151a2e",
          borderRadius: "12px",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.5)",
          border: "1px solid #1e2541"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px 24px",
            borderBottom: "1px solid #1e2541",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <h5 style={{ margin: 0, color: "#ffffff", fontWeight: "600" }}>
            {t('auth.reset_password')}
          </h5>
          <button
            onClick={handleClose}
            style={{
              background: "transparent",
              border: "none",
              color: "#a0aec0",
              fontSize: "24px",
              cursor: "pointer",
              padding: 0,
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "24px" }}>
          {success ? (
            <div
              style={{
                background: "rgba(0, 192, 135, 0.1)",
                border: "1px solid #00c087",
                borderRadius: "8px",
                padding: "16px",
                color: "#00c087"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                <i className="fa fa-check-circle" style={{ fontSize: "24px", marginRight: "12px" }}></i>
                <strong style={{ fontSize: "16px" }}>Email Sent</strong>
              </div>
              <p style={{ margin: 0, fontSize: "14px", color: "#a0aec0", lineHeight: "1.6" }}>
                If the email exists in our system, a password reset link has been sent to your email address.
                <br /><br />
                <strong style={{ color: "#ffffff" }}>Next steps:</strong>
                <br />
                1. Check your inbox (and spam folder)
                <br />
                2. Click on the link in the email
                <br />
                3. Set your new password
                <br /><br />
                <small style={{ color: "#888" }}>
                  The link will expire after some time. If you don't receive the email, please verify that the email address is correct.
                </small>
              </p>
            </div>
          ) : (
            <>
              {error && (
                <div
                  style={{
                    background: "rgba(255, 92, 92, 0.1)",
                    border: "1px solid #ff5c5c",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "#ff5c5c",
                    marginBottom: "16px",
                    fontSize: "14px"
                  }}
                >
                  {error}
                </div>
              )}
              <p style={{ color: "#a0aec0", fontSize: "14px", marginBottom: "20px" }}>
                {t('auth.reset_password_instructions')}
              </p>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      color: "#ffffff",
                      fontSize: "14px",
                      fontWeight: "500"
                    }}
                  >
                    {t('auth.email')}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder={t('auth.email')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    style={{
                      background: "#0a0e27",
                      border: "1px solid #1e2541",
                      borderRadius: "8px",
                      color: "#ffffff",
                      padding: "12px 16px",
                      fontSize: "14px",
                      width: "100%"
                    }}
                  />
                </div>
              </form>
            </>
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "16px 24px",
            borderTop: "1px solid #1e2541",
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px"
          }}
        >
          {success ? (
              <button
              onClick={handleClose}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                background: "#00c087",
                border: "none",
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              {t('common.close')}
            </button>
          ) : (
            <>
              <button
                onClick={handleClose}
                disabled={loading}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  background: "transparent",
                  border: "1px solid #1e2541",
                  color: "#a0aec0",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.6 : 1
                }}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={handleSubmit}
                disabled={loading || !email}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  background: loading || !email ? "#1f2640" : "#00c087",
                  border: "none",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: loading || !email ? "not-allowed" : "pointer",
                  opacity: loading || !email ? 0.6 : 1
                }}
              >
                {loading ? t('auth.sending') : t('auth.send')}
              </button>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ForgotPasswordModal;

